import React from 'react';
import { CalendarHeartIcon } from 'lucide-react';
import { goToCart } from './constants';
type Props = {
  label?: string;
  className?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  label = 'QUIERO MIS 28 MINUTOS DE VUELTA',
  className = '',
  size = 'lg'
}: Props) {
  const sizing = size === 'lg' ? 'px-6 py-5 text-base sm:text-lg' : 'px-5 py-4 text-sm sm:text-base';
  return <button type="button" onClick={goToCart} className={`group relative inline-flex w-full items-center justify-center gap-2.5 rounded-2xl bg-magenta font-extrabold uppercase tracking-tight text-white shadow-[0_10px_0_0_#c00e69] transition-all duration-150 hover:-translate-y-0.5 hover:shadow-[0_12px_0_0_#c00e69] active:translate-y-1 active:shadow-[0_4px_0_0_#c00e69] ${sizing} ${className}`} data-id="element-59">
      <CalendarHeartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-60" />
      <span className="leading-tight" data-id="element-61">{label}</span>
    </button>;
}